import _ from "lodash";
import React from "react";
import Message from "./Message";

import "./Messages.less";

export default React.createClass({

  getInitialState() {
    return {};
  },

  render() {
    let {
      order = "asc",
      messages,
      onMarkAsRead,
      blurMessages
    } = this.props;

    messages = _.sortBy(messages, "created");
    if (order === "desc") {
      messages = messages.reverse();
    }

    messages = _.map(messages, function (msg, i) {
      let name = null;
      if (msg.sender_buyer_id > 0 && !_.includes(_.get(msg, ["flags_as_array"], []), "system_log")) {
        name = _.get(msg, ["sender_buyer_name"]);
      }
      let is_marketplace_message = _.includes(_.get(msg, ["flags_as_array"], []), "system_log");
      let is_you = !name && !is_marketplace_message;
      let is_unread = !is_you && !msg.receiver_opened;

      return (
        <Message
          key={_.get(msg, ["id"], i)}
          id={_.get(msg, ["id"])}
          blur_message={blurMessages}
          sender_name={name}
          is_you={is_you}
          is_unread={is_unread}
          timestamp={_.get(msg, ["created"])}
          content={_.get(msg, ["content"])}
          contact_info_found={_.get(msg, ["flags_as_map", "contact_info_found", "is_set"])}
          is_marketplace_message={is_marketplace_message}
          onMarkAsRead={onMarkAsRead}
        />
      );
    });

    return (
      <div>
        <div className="MP-Messages">
          <div style={{
            position: "relative", /*fixes scroll hints*/
          }}>
            {messages}
          </div>
        </div>
      </div>
    );
  }
});


// WEBPACK FOOTER //
// ./src/components/marketplace/Messages.js